import { defaultError } from '@qpr/client-library';
import api, { ApiRequest, ApiResult } from '../../../api/api-caller';
import initialState, { ProcessIntegrationViewState } from '../process-integration-state';

interface CacheData {
  [key: string]: any;
}

const errorHandler = (apiResult: ApiResult): ProcessIntegrationViewState => {
  return {
    ...initialState,
    error: apiResult.error || defaultError
  };
};

const getE2eProcessesFromAPI = async (): Promise<ApiResult> => {
  const req: ApiRequest = {
    method: 'GET'
  };
  const result: ApiResult = await api.asyncCallApi('e2eprocesses', req);

  return result;
};

const viewModelCache: CacheData = {};

const createViewModel = () => {
  let response: ApiResult;

  const fetchE2eProcesses = async (): Promise<ApiResult> => {
    const cacheKey: string = '';

    if (viewModelCache[cacheKey]) {
      console.log('From cache', viewModelCache[cacheKey]);
      response = viewModelCache[cacheKey];
    } else {
      response = await getE2eProcessesFromAPI();

      viewModelCache[cacheKey] = response;
    }
    return response;
  };

  const getData = async (): Promise<ProcessIntegrationViewState> => {
    if (!response) {
      try {
        response = await fetchE2eProcesses();
        if (!response.ok) return errorHandler(response);

        if (!response.data || response.data.length < 1)
          return {
            ...initialState,
            error: {
              message: 'No E2E processes available.',
              details: 'No E2E processes found.'
            }
          };
      } catch (error) {
        return {
          ...initialState,
          error: { message: 'Something went wrong', details: JSON.stringify(error) }
        };
      }
    }
    return {
      ...initialState,
      e2eProcesses: response.data
    };
  };

  return { getData };
};

export default createViewModel;
